import { render, staticRenderFns } from "./AndroidConfig.vue?vue&type=template&id=5ffc2824"
import script from "./AndroidConfig.vue?vue&type=script&lang=js"
export * from "./AndroidConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports